import { create } from "zustand";
import { persist } from 'zustand/middleware'

export const userStore = create(
  persist(
    (set) => ({
      user: {},
      selectedBotId: '',
      setUser: (user) => set({ user }),
      setSelectedBotId: (selectedBotId) => set({ selectedBotId }),
      resetUserStore: () => {
        set({
          user: {},
          selectedBotId: ''
        });
      }
    }),
    {
      name: 'user-storage',
      getStorage: () => localStorage
    }

  )
)